import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  CarOutlined,
  InboxOutlined,
  CloseCircleOutlined,
  DollarCircleOutlined,
  CheckOutlined,
  UndoOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';

// Delivery Status Options
export const DELIVERY_STATUS_OPTIONS = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Confirmed', value: 'CONFIRMED' },
  { label: 'Shipped', value: 'SHIPPED' },
  { label: 'Delivered', value: 'DELIVERED' },
  { label: 'Cancelled', value: 'CANCELLED' },
] as const;

// Payment Status Options
export const PAYMENT_STATUS_OPTIONS = [
  { label: 'Unpaid', value: 'UNPAID' },
  { label: 'Paid', value: 'PAID' },
  { label: 'Partially Paid', value: 'PARTIALLY_PAID' },
  { label: 'Cancelled', value: 'CANCELLED' },
] as const;

// Filter Options
export const DELIVERY_STATUS_FILTER_OPTIONS = DELIVERY_STATUS_OPTIONS;
export const PAYMENT_STATUS_FILTER_OPTIONS = PAYMENT_STATUS_OPTIONS;

// Delivery Status Colors
export const DELIVERY_STATUS_COLORS = {
  PENDING: 'orange',
  CONFIRMED: 'blue',
  SHIPPED: 'cyan',
  DELIVERED: 'green',
  CANCELLED: 'red',
} as const;

// Payment Status Colors
export const PAYMENT_STATUS_COLORS = {
  UNPAID: 'orange',
  PAID: 'green',
  PARTIALLY_PAID: 'blue',
  CANCELLED: 'red',
} as const;

// Delivery Status Icons
export const DELIVERY_STATUS_ICONS = {
  PENDING: <ClockCircleOutlined />,
  CONFIRMED: <CheckCircleOutlined />,
  SHIPPED: <CarOutlined />,
  DELIVERED: <InboxOutlined />,
  CANCELLED: <CloseCircleOutlined />,
} as const;

// Payment Status Icons
export const PAYMENT_STATUS_ICONS = {
  UNPAID: <DollarCircleOutlined />,
  PAID: <CheckOutlined />,
  PARTIALLY_PAID: <ExclamationCircleOutlined />,
  CANCELLED: <CloseCircleOutlined />,
} as const;
